class Prices {
    constructor() {
        this.prices = document.querySelectorAll('.js-prices');
        if (this.prices.length) {
            this.prices.forEach((prices) => {
                Prices.bindPrices(prices);
            });
        }
    }

    static bindPrices(prices) {
        prices.querySelectorAll('.js-category-select').forEach((item) => {
            item.addEventListener('click', () => {
                if (item.classList.contains('selected')) {
                    return;
                }
                prices.querySelectorAll('.js-category-select.selected').forEach((selected) => {
                    selected.classList.remove('selected');
                });
                item.classList.add('selected');
                prices.querySelectorAll('.js-category').forEach((selected) => {
                    selected.classList.add('hidden');
                });
                prices.querySelector(`.js-category[data-category-id="${item.dataset.categoryId}"]`).classList.remove('hidden');
            });
        });
    }
}

export default Prices;
